import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { StepChildrenComponent } from '../step-children-component';

export interface ActionButtonLabels {
	save?: string;
	send?: string;
	cancel?: string;
	previous?: string;
	next?: string;
}

@Component({
	selector: 'app-action-buttons',
	templateUrl: './action-buttons.component.html',
	styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent {
	@Input() onSave!: () => void;
	@Input() onSend!: () => void;
	@Input() onCancel?: () => void;
	@Input() onNext?: () => void;
	@Input() onPrevious?: () => void;

	// Step management
	@Input() children?: StepChildrenComponent;
	@Input() parentTab?: MatTabGroup;
	@Input() previousTab?: number;
	@Input() nextTab?: number;

	// Form/UI state
	@Input() completedForm: boolean = false;
	@Input() disableSave: boolean = false;
	@Input() isLoading: boolean = false;
	@Input() hideSend: boolean = false;

	// Current tab indices
	@Input() currentHorizontalTabIndex: number = 0;
	@Input() currentVerticalTabIndex: number = 0;

	// Labels
	@Input() labelSave: string = 'Guardar';
	@Input() labelSend: string = 'Enviar';
	@Input() labelCancel: string = 'Cancelar';
	@Input() labelPrevious: string = 'Atrás';
	@Input() labelNext: string = 'Siguiente';

	@Output() validateBeforeNavigation = new EventEmitter<{ horizontal: number; vertical: number }>();

	get previousLabel(): string {
		return this.labelPrevious;
	}

	get nextLabel(): string {
		return this.labelNext;
	}

	get saveLabel(): string {
		return this.labelSave;
	}

	get sendLabel(): string {
		return this.labelSend;
	}

	get cancelLabel(): string {
		return this.labelCancel;
	}

	get hasPrevious(): boolean {
		if (this.previousTab !== undefined) {
			return true;
		}
		return this.children?.hasPrevious ?? false;
	}

	get hasNext(): boolean {
		if (this.nextTab !== undefined) {
			return true;
		}
		return this.children?.hasNext ?? false;
	}

	handleSave(): void {
		this.onSave();
	}

	handleSend(): void {
		this.onSend();
	}

	handleCancel(): void {
		if (this.onCancel) {
			this.onCancel();
		}
	}

	handleNext(): void {
		this.emitValidation();

		// If the current step is the last one and there is no next step, change tab if exists
		if (!this.children?.hasNext && this.children?.isLastIndex) {
			if (this.nextTab !== undefined && this.parentTab) {
				this.parentTab.selectedIndex = this.nextTab;
				return;
			}
		}

		if (this.onNext) {
			this.onNext();
		} else {
			this.children?.onNext();
			this.children?.scrollToTop?.();
		}
	}

	handlePrevious(): void {
		this.emitValidation();

		// If the current step is the first one and there is no previous step, change tab if exists
		if (!this.children?.hasPrevious && this.children?.isFirstIndex) {
			if (this.previousTab !== undefined && this.parentTab) {
				this.parentTab.selectedIndex = this.previousTab;
				return;
			}
		}

		if (this.onPrevious) {
			this.onPrevious();
		} else {
			this.children?.onPrevious();
			this.children?.scrollToTop?.();
		}
	}

	private emitValidation(): void {
		this.validateBeforeNavigation.emit({
			horizontal: this.currentHorizontalTabIndex,
			vertical: this.currentVerticalTabIndex
		});
	}
}
